// Generated by CoffeeScript 2.7.0
var ButtonDropdown, capturedBackdrop;

({capturedBackdrop} = Skylark.Helpers.App);

export default ButtonDropdown = class ButtonDropdown {
  static init() {
    return _.each(DomMaster.findAll('.js-btn-dropdown'), (element) => {
      return new this(element);
    });
  }

  constructor(element1) {
    this.element = element1;
    this.opend = false;
    this.element.node.proxy('click', '.btn-addon', (event) => {
      if (this.opend) {
        return this.close();
      } else {
        this.open();
        return capturedBackdrop((event) => {
          return this.close();
        }, void 0);
      }
    });
  }

  close() {
    this.opend = false;
    return this.element.removeClass('open');
  }

  open() {
    this.opend = true;
    return this.element.addClass('open');
  }

};
